import React, { Component } from "react";

import styles from "./DeclineOverlay.scss";

class DeclineOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: "",
      messageAdded: false
    };
  }

  onMessageChange = event => {
    this.setState({
      ...this.state,
      message: event.target.value
    });
  };

  showMessage = () => {
    this.setState({
      ...this.state,
      messageAdded: true
    });
  };

  confirm = () => {
    const { onConfirm } = this.props;
    const { message } = this.state;

    onConfirm(message);
  };

  cancel = () => {
    const { onCancel } = this.props;

    onCancel();
  };

  render() {
    const { name } = this.props;

    const { message, messageAdded } = this.state;

    return (
      <div className={styles.overlay} style={{ lineHeight: "1.33em" }}>
        <h3>
          Decline {name}
          's Proposal
        </h3>

        {!messageAdded ? (
          <React.Fragment>
            <div className={styles.divider} />
            <div className={styles.subheading}>
              She will receive a notification that you declined her pitch, but
              you can also add a personal message below. (Optional)
            </div>

            <button
              type="button"
              className={styles.addMessage}
              onClick={this.showMessage}
            >
              Add message
            </button>
          </React.Fragment>
        ) : (
          <textarea
            className={styles.message}
            onChange={this.onMessageChange}
            value={message}
            placeholder="Tell the member why you're not interested in her proposal. (Optional)"
          />
        )}

        <button type="button" className={styles.confirm} onClick={this.confirm}>
          Decline
        </button>
        <button type="button" className={styles.cancel} onClick={this.cancel}>
          Wait, nevermind!
        </button>
      </div>
    );
  }
}

export default DeclineOverlay;



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/components/candidates/DeclineOverlay.js